// src/pages/admin/GroupDelete.jsx
import React from 'react';

export default function GroupDelete() {
  return (
    <div>
      <h2>Group Delete</h2>
      <p>Delete group fare cards that are no longer active.</p>
    </div>
  );
}
